import ApplicationStateProvider from './ApplicationStateProvider';
import { QueryClient, QueryClientProvider } from 'react-query';
import React, { Fragment } from 'react';
import ApplicationActionsProvider from './ApplicationActionsProvider';
import { OpenLayersProvider } from '../react-ol/openlayers-context';
import { ThemeProvider } from 'styled-components';
import { theme } from '../theme';
import { useDeepCompareMemoize } from 'use-deep-compare-effect';
var queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnReconnect: false,
      refetchOnWindowFocus: false
    }
  }
});

var MapProvider = _ref => {
  var {
    apiUrl,
    apiKey,
    overrides,
    onTileLoadError,
    children
  } = _ref;
  var memoizedOverrides = useDeepCompareMemoize(overrides);

  if (!apiUrl || !apiKey) {
    console.error("Could not render map. MapProvider was not passed an".concat(apiUrl ? '' : ' API URL').concat(apiUrl || apiKey ? '' : ' or').concat(apiKey ? '' : ' API Key'));
    return /*#__PURE__*/React.createElement(Fragment, null);
  }

  return /*#__PURE__*/React.createElement(QueryClientProvider, {
    client: queryClient
  }, /*#__PURE__*/React.createElement(OpenLayersProvider, null, /*#__PURE__*/React.createElement(ApplicationStateProvider, {
    apiUrl: apiUrl,
    apiKey: apiKey,
    overrides: memoizedOverrides,
    onTileLoadError: onTileLoadError
  }, /*#__PURE__*/React.createElement(ApplicationActionsProvider, null, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, children)))));
};

export default MapProvider;